import createAction from "../HelperFunctions";
import { TASKSHEET_TYPES } from "./tasksheet.types";

export const dispatchLogInToTaskSheet = (userId, password) => createAction(TASKSHEET_TYPES.LOG_IN, {userId, password})